import API, { defaultHeaders } from '@/api';
import Storage from '@/service/Storage';

const invitations = () => {
  const headers = Object.assign({}, defaultHeaders);
  headers.Authorization = `Bearer ${Storage.getItem('token')}`;
  return fetch(`${API}/invitations`, { headers });
};

export default invitations;
